import { PPT_LIMITS } from '../constants';
import { getSize, readBytes } from '../fileInputUtils';
import type { FileInput, ValidationResult } from '../types';
import { formatBytes } from '../utils';

export async function validatePpt(input: FileInput): Promise<ValidationResult> {
  const size = getSize(input);

  if (size < PPT_LIMITS.min)
    return {
      valid: false,
      reason: `Too small — minimum valid PPT is 1536 bytes (3 × 512-byte sectors)`,
    };
  if (size > PPT_LIMITS.max)
    return { valid: false, reason: `Exceeds max size (${formatBytes(PPT_LIMITS.max)})` };

  // Check OLE2 header (D0 CF 11 E0 A1 B1 1A E1)
  const header = await readBytes(input, 0, 32);
  const isOLE =
    header[0] === 0xd0 &&
    header[1] === 0xcf &&
    header[2] === 0x11 &&
    header[3] === 0xe0 &&
    header[4] === 0xa1 &&
    header[5] === 0xb1 &&
    header[6] === 0x1a &&
    header[7] === 0xe1;

  if (!isOLE)
    return { valid: false, reason: 'Invalid PPT header — missing OLE2 signature (D0CF11E0...)' };

  const sectorShift = header[30]! | (header[31]! << 8);
  const sectorSize = sectorShift === 0x000c ? 4096 : 512;

  if (size % sectorSize !== 0)
    return {
      valid: false,
      reason: `File size not aligned to ${sectorSize}-byte sector boundary — likely truncated`,
    };

  return { valid: true };
}
